import "./App.css";
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";

import Home from "./Pages/Home";
import { Footer } from "./Layout/Footer";
import { Header } from "./Layout/Header";
import About from "./Pages/About";
import AllCourses from "./Pages/All Courses/AllCourses";
import RemoteSensing from "./Pages/All Courses/RemoteSensing";
import Animation from "./Pages/All Courses/Animation";
import IndustrialTraining from "./Pages/All Courses/IndustrialTraining";
import AugumentedReality from "./Pages/All Courses/AugumentedReality";
import Fashion from "./Pages/All Courses/Fashion";
import ATCRegistration from "./Pages/Apply Now/ATCRegistration";
import StudentRegistration from "./Pages/Apply Now/StudentRegistration";
import Contact from "./Pages/Contact";
import Training from "./Pages/Training";
import ApplyFranchise from "./Pages/ApplyFranchise";
import Abacus from "./Pages/All Courses/Abacus";
import University from "./Pages/All Courses/University";
import ATCdetails from "./Components/ATCdetails";
import ATCRegistrationForm from "./Components/ATCRegistrationForm";
import ATCTerms from "./Components/ATCTerms";
import StudentPRN from "./Components/StudentPRN";
import Refund from "./Components/Refund";
import IntellectualProp from "./Components/IntellectualProp";
import ProductFlow from "./Components/ProductFlow";
import Certificates from "./Components/Certificates";

import { loadTemplateScriptsOnce, reloadOnRouteChange } from "./Hooks/templateInit";
import FranchiseDirector from "./Components/FranchiseDirector";
import StudentRegistrationForm from "./Components/StudentRegistrationForm";
import StudentEnrollments from "./Pages/StudentEnrollments";

function TemplateLoaderWithReload() {
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      await loadTemplateScriptsOnce();
      reloadOnRouteChange(location.pathname);
    };

    run();
  }, [location.pathname]);

  return null;
}


function App() {
  return (
    <>
      <Router>
        <TemplateLoaderWithReload />

        <Header />

        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/allcourses" element={<AllCourses />} />
            <Route path="/remotesensing" element={<RemoteSensing />} />
            <Route path="/animation" element={<Animation />} />
            <Route path="/industrialtraining" element={<IndustrialTraining />} />
            <Route path="/augumentedreality" element={<AugumentedReality />} />
            <Route path="/fashion" element={<Fashion />} />
            <Route path="/atcregistration" element={<ATCRegistration />} />
            <Route path="/registration" element={<StudentRegistration />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/training" element={<Training />} />
            <Route path="/applyfrenchise" element={<ApplyFranchise />} />
            <Route path="/abacus" element={<Abacus />} />
            <Route path="/university" element={<University />} />
            <Route path="/atcdetails" element={<ATCdetails />} />
            <Route path="/atcregform" element={<ATCRegistrationForm />} />
            <Route path="/atcTerms" element={<ATCTerms />} />
            <Route path="/Verification/:enrollment_number?" element={<StudentPRN />} />
            <Route path="/refund" element={<Refund />} />
            <Route path="/intellectual" element={<IntellectualProp />} />
            <Route path="/product" element={<ProductFlow />} />
            <Route path="/certificate" element={<Certificates />} />
            <Route path="/FranchiseDirector/:franchise_id" element={<FranchiseDirector />} />
            <Route path="/StudentRegistration/:franchise_id/:franchise_name" element={<StudentRegistrationForm />} />
            <Route path="/StudentEnrollments/:student_pnr?" element={<StudentEnrollments />} />
          </Routes>
        </div>

        <Footer />
      </Router>
    </>
  );
}

export default App;
